import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import LimitReachedTooltip from '~/components/isolated/LimitReachedTooltip';

import styles from './Counter.module.scss';
import type { CounterProps } from './interfaces';

const Counter = ({
  value,
  onIncrement,
  onDecrement,
  isDecrementDisabled,
  classes,
  calculatedPrice,
  limit,
  limitReachedText,
  openLimitTooltipOnMount,
}: CounterProps) => {
  const { t } = useTranslation();
  const {
    root: className,
    buttonClassName,
    incrementClassName,
    decrementClassName,
    valueClassName,
    valueWrapperClassName,
    disabledClassName = styles.disabled,
  } = classes || {};

  const incrementDisabled = value >= (limit || 0);

  return (
    <>
      <LimitReachedTooltip
        isLimitReached={incrementDisabled}
        openOnMount={openLimitTooltipOnMount}
        className="pointer-events-none"
      >
        {limitReachedText ?? t('noMoreInStock')}
      </LimitReachedTooltip>
      <div className={htmlClasses([styles.counter, className])}>
        <button
          className={htmlClasses([
            styles.button,
            buttonClassName,
            decrementClassName,
          ])}
          onClick={onDecrement}
          disabled={isDecrementDisabled}
        >
          <Icon type="minus" size={32} />
        </button>
        <div
          className={htmlClasses([styles.valueWrapper, valueWrapperClassName])}
        >
          <span className={htmlClasses([styles.value, valueClassName])}>
            {value}
          </span>
          {calculatedPrice}
        </div>
        <button
          className={htmlClasses([
            styles.button,
            buttonClassName,
            incrementClassName,
            incrementDisabled && disabledClassName,
          ])}
          onClick={onIncrement}
          disabled={incrementDisabled}
        >
          <Icon type="plus" size={32} />
        </button>
      </div>
    </>
  );
};

export default observer(Counter);
